export default [
  ...Array.from({ length: 23 }, (_, i) => ({
    id: i + 13,
    amount_in_vat: 0,
    amount_ex_vat: 0,
    amount_currency: 'EUR',
    hour: (i + 13) % 24,
    day: (i + 13) % 24 === 0 ? '2000-1-02' : '2000-1-01',
  })),
];
